import { Injectable } from '@angular/core';
import { DevstroupeDrawerComponent } from '@devstroupe/components/drawer/drawer.component';

@Injectable({providedIn: 'root'})
export class DevstroupeDrawerService
{
    private _componentRegistry: Map<string, DevstroupeDrawerComponent> = new Map<string, DevstroupeDrawerComponent>();

    /**
     * Constructor
     */
    constructor()
    {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Register drawer component
     *
     * @param name
     * @param component
     */
    registerComponent(name: string, component: DevstroupeDrawerComponent): void
    {
        this._componentRegistry.set(name, component);
    }

    /**
     * Deregister drawer component
     *
     * @param name
     */
    deregisterComponent(name: string): void
    {
        this._componentRegistry.delete(name);
    }

    /**
     * Get drawer component from the registry
     *
     * @param name
     */
    getComponent(name: string): DevstroupeDrawerComponent | undefined
    {
        return this._componentRegistry.get(name);
    }
}
